import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import LeadService from "../Lead/Controller/CommunicationController";
import { ThemeContext } from "../Layout/Theme/ThemeContext";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Draggable from 'react-draggable';
import EmailPreviewModal from './EmailPreviewModal';
import SunTextEditor from "./SunTextEditor";
function SendEmail({ onClose, ToEmail, Module, ModuleID }) {

    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [formData, setFormData] = useState({
        ID: 0, vc_Subject: '', vc_Description: '',
        vc_From: localStorage.getItem('Email'), vc_To: ToEmail, vc_CC: '',
        Module: Module, ModuleID: ModuleID, EmailFooter: localStorage.getItem('EmailFooter'),
        DisplayName: localStorage.getItem('DisplayName')

    });
    const [showEmailPreview, setShowEmailPreview] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_Description: content
        });
    };



    const handleFormSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            const errors = {};
            if (!formData.vc_Description || formData.vc_Description === "") {
                errors.vc_Description = 'This field is required';
            }
            if (!isValidEmail(formData.vc_From)) {
                errors.vc_From = 'Please enter a valid email address';
            }
            if (!isValidEmail(formData.vc_To)) {
                errors.vc_To = 'Please enter a valid email address';
            }
            if (formData.vc_CC) {
                if (!isValidEmail(formData.vc_CC)) {
                    errors.vc_CC = 'Please enter a valid email address';
                }
            }
            setErrors(errors);
            if (Object.keys(errors).length === 0) {
                const postData = await LeadService.LeadSendEmail(formData);
                localStorage.setItem('HasRecordUpdated', "1");
                onClose();
            }
        }
        catch (error) {
            console.error('Error fetching Contacts:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }
    };
    const isValidEmail = (email) => {
        // You can implement a regex or use a library like validator.js to validate email format
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    };



    return (
        <div>
            {loading && (
                <div class="loading" style={{ zIndex: "10000" }}>
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade customerHistoryModal show d-block" id="customerHistoryModal" tabIndex="-1" aria-labelledby="customerHistoryModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-header" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                             bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">Send Email</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">

                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                        <label htmlFor="vc_From" className="col-sm-2 col-form-label">From</label>
                                        <div className="col-sm-4">
                                            <input type="text" className="form-control" name="vc_From" value={formData.vc_From} onChange={handleFieldChange} disabled={formData.snt_CommunicationType === '0'} />
                                            {errors.vc_From && <div style={{ color: 'red' }}>{errors.vc_From}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="vc_To" className="col-sm-2 col-form-label">To</label>
                                        <div className="col-sm-4">
                                            <input type="text" className="form-control" name="vc_To" value={formData.vc_To} onChange={handleFieldChange} disabled={formData.snt_CommunicationType === '0'} />
                                            {errors.vc_To && <div style={{ color: 'red' }}>{errors.vc_To}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="vc_CC" className="col-sm-2 col-form-label">CC</label>
                                        <div className="col-sm-4">
                                            <input type="text" className="form-control" name="vc_CC" value={formData.vc_CC} onChange={handleFieldChange} disabled={formData.snt_CommunicationType === '0'} />
                                            {errors.vc_CC && <div style={{ color: 'red' }}>{errors.vc_CC}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="vc_Subject" className="col-sm-2 col-form-label">Subject:</label>
                                        <div className="col-sm-10">
                                            <input type="text" className="form-control" name="vc_Subject" value={formData.vc_Subject} onChange={handleFieldChange} />
                                            {errors.vc_Subject && <div style={{ color: 'red' }}>{errors.vc_Subject}</div>}
                                        </div>
                                    </div>

                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="vc_Description" className="col-sm-2 col-form-label">Description:<span style={{ "color": "red" }}>*</span></label>
                                        <div className="col-sm-10">
                                            
                                            <SunTextEditor
                                                value={formData.vc_Description}
                                                onChange={(content) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        vc_Description: content,
                                                    }))
                                                }
                                            />
                                            {errors.vc_Description && <div style={{ color: 'red' }}>{errors.vc_Description}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="vc_Description" className="col-sm-2 col-form-label"><span style={{ "color": "red" }}>*</span></label>
                                        <div className="col-sm-10">
                                            <button type="button" className="btn btn-info" onClick={() => setShowEmailPreview(true)}>
                                                Preview Email
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                        <i class="icofont-send-mail"></i>
                                            Send
                                       
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                       <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
            {(showEmailPreview &&
                <EmailPreviewModal

                    onClose={() => setShowEmailPreview(false)}
                    subject={formData.vc_Subject}
                    description={formData.vc_Description}
                    footer={formData.EmailFooter}
                    to={formData.vc_To}
                    cc={formData.vc_CC}
                />
            )}
        </div>
    );
}
export default SendEmail;
